@if (isQuestionStep(); as step) {
  @switch (step.question.imageTemplate) {
    @case (imagePositionOnPage.IMAGE_LEFT_OF_QUESTION) {
      <lib-image-left-of-question [step]="step" [isLoading]="isFetching()" />
    }
    @case (imagePositionOnPage.IMAGE_IN_SIDE_PANE) {
      <lib-image-in-side-pane [step]="step" [isLoading]="isFetching()" />
    }
    @case (imagePositionOnPage.IMAGE_BENEATH_QUESTION) {
      <lib-image-beneath-question [step]="step" [isLoading]="isFetching()" />
    }
    @case (imagePositionOnPage.IMAGES_IN_SLIDES) {
      <lib-images-in-slides [step]="step" [isLoading]="isFetching()" />
    }
    @default {
      <lib-no-image [step]="step" [isLoading]="isFetching()" />
    }
  }
}
@if (isThankYouStep(); as step) {
  <lib-thank-you [step]="step" />
}
